import axios from 'axios';
// import { store } from '../index.js';
// import { setAlertMessage } from 'store/slices/generalSlice';
// import { severities } from 'utils/consts';

export const frontApi = axios.create({
  baseURL: process.env['REACT_APP_SERVER_URL'],
});


export const botApi = axios.create({
  baseURL: `${process.env['REACT_APP_BOTS_URL']}:${process.env['REACT_APP_BOTS_PORT']}`,
});

// frontApi.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     console.error(error);
//     // store.dispatch(setAlertMessage({
//     //     message: "Network error occurred please try again later",
//     //     type: severities.error
//     // }));
//     return Promise.reject(error);
//   },
// );

export const setToken = (token) => {
  if (token) {
    frontApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete frontApi.defaults.headers.common['Authorization'];
  }
};

export const API_ROUTES = {
  cap: {
    allDecks: 'cap/decks',
    decks: (lang) => `cap/decks/playable/${lang}`,
  },
  puns: {
    categories: (lang) => `pun/category/${lang}`,
  },
  stats: (profileId) => `stats/all/${profileId}`,
  user: {
    profile: (username) => `profile/${username}`,
    activate: (query) => `user/activate/${query}`
  },
  allPlayersInRoom: (shortname, roomId) => `${shortname}/allPlayersInRoom/${roomId}`,
  kickPlayerFromRoom: (shortname) => `${shortname}/removePlayerFromRoom`,
  createRoom: (shortname) => `${shortname}/createRoom`,
  closeEmptyRoom: (shortname) => `${shortname}/closeRoom`,
  badges: 'badge',
  login: 'auth/login',
  profile: {
    get: 'profile/get',
    edit: `profile/edit`,
  },
  users: {
    get: '/admin/users/all',
    setRole: '/admin/users/setRole',
    ban: '/admin/users/ban',
    unBan: '/admin/users/unBan',
  },
  roles: '/role',
  games: '/game',
  languages: {
    all: '/language',
    game: (id) => `/language/used/${id}`,
    used: (game) => `language/used/${game}`,
  },
  devMsg: '/admin/devMsg',
  posts: '/post',
  bots: {
    join: '/join',
    status: '/status',
    remove: '/remove',
    removeAll: '/removeAll',
    bot: '/bot'
  }
};
